import React from 'react'

export const Login = React.lazy(() => import('@/pages/public/login'))
export const ForgotPassword = React.lazy(() => import('@/pages/public/forgot.password'))
export const VerifyOTP = React.lazy(() => import('@/pages/public/verify.otp'))
export const ResetPassword = React.lazy(() => import('@/pages/public/reset.password'))